import { useOAIQuery } from '~/hooks/reactQuery';
import { useRouterQueryByKey } from '~/hooks/url';

export const useCurrentVendorInfo = () => {
  const vendorId = useRouterQueryByKey('vendorId', 'number');
  const query = useOAIQuery({
    queryKey: '/api/market-place/v1/vendors/{vendorId}',
    variables: { vendorId },
    queryOptions: {
      enabled: !!Number(vendorId),
    },
  });

  return query;
};

/**
 * @description 해당 벤더사에서 운영중인 쇼케이스 or 쇼케이스 그룹 리스트 조회
 * */
export const useVendorShowcaseList = (vendorId: number) => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/vendor/{vendorId}/display',
    variables: { vendorId },
    queryOptions: {
      enabled: !!Number(vendorId),
    },
  });
};
